import InstallerRow from "./InstallerRow";

export default InstallerRow;
